import { isApiError } from '@shigo-ui/api-client';
import { toast } from '@shigo-ui/ui';

import { dashboardApiErrorMessage } from './apiErrorMessages';
import { dashboardT } from './messages';

const notifiedErrors = new WeakSet();

/** Share notification ownership between the query cache and the calling form. */
export function markRequestErrorNotified(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) return false;
  if (notifiedErrors.has(error)) return true;
  notifiedErrors.add(error);
  return false;
}

export function showRequestError(
  error: unknown,
  fallback = dashboardT('api.common.requestFailed'),
) {
  if (markRequestErrorNotified(error)) return;
  toast.error(isApiError(error) ? dashboardApiErrorMessage(error) : fallback);
}
